import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { message } from 'antd';
import { UserInfo } from '@/service/user/type.d';
import { UserService } from '@/service';

export const fetchUserInfoAsync = createAsyncThunk('post/userInfo', async () => {
  const response = await UserService.fetchUserInfo();
  if (response.code) {
    message.error(response.message || response.reason);
    return;
  }
  return response;
});

const initialState: UserInfo = {
  currentTeamId: '0',
};

const user = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserInfo(state, action) {
      return {
        ...action.payload.data,
      };
    },
  },
  extraReducers(builder) {
    builder.addCase(fetchUserInfoAsync.fulfilled, (state, action) => {
      return action.payload?.data;
    });
  },
});

export const actions = user.actions;
export const reducer = user.reducer;
